"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const normal_attack_1 = tslib_1.__importDefault(require("../common/normal-attack"));
exports.kiseirei_skill1 = new normal_attack_1.default('投火');
